<div class="no-data-wrapper">
	<div class="col-one">
		<mat-icon class="text-info">info</mat-icon>
	</div>
	<div class="col-two">
		<span>{{ message }}</span>
	</div>
</div>
